import { TranslationRecord } from '../../TranslationRecord';

export const plTranslations: TranslationRecord = {
  ERROR: 'Błąd',
  PHONE_NUMBER: 'Numer telefonu',
  UPLOAD_IMAGE: 'Dodaj zdjęcie z miejsca zdarzenia',
  SELECT_FILE_FROM_DISK: 'Wybierz plik z dysku',
  DESKTOP_UPLOAD_IMAGE_TITLE: 'Przenieś i upuść plik tutaj lub kliknij, aby dodać plik z dysku',
  DESKTOP_UPLOAD_IMAGE_ADDITIONAL_TEXT: 'Dostępny format .jpg, .png, .bmp maks. 4MB',
  MOBILE_UPLOAD_IMAGE_TITLE: 'Zrób zdjęcie lub Dodaj plik z dysku',
  FORM_TITLE: 'Zamów Assistance poprzez przesłanie zdjęcia z miejsca zdarzenia',
  CONSENT_TO_CONTACT_AND_READ_INFO: 'Wyrażam zgodę na kontakt telefoniczny i zapoznałem/łam się z',
  INFORMATION_REGARDING_DATA_PROCESSING: 'informacją dotyczącą przetwarzania danych.',
  PHONE_NUMBER_HELPER_TEXT: 'Umożliwi nam szybki kontakt z Tobą',
  INFO_CARD_TITLE: 'Jak to działa?',
  INFO_CARD_CONTENT_1:
    '1. Dodajesz zdjęcie z wypadku z widoczną tablicą rejestracyjną. Ze zdjęcia poznajemy miejsce zdarzenia.\n',
  INFO_CARD_CONTENT_2: '2. Informacje o pomocy otrzymasz telefonicznie.',
  NEXT: 'Dalej',
  MAKE_PHOTO_INSTRUCTION_TITLE: 'Jak poprawnie wykonać zdjęcie?',
  MAKE_PHOTO_INSTRUCTION_CONTENT:
    'Wykonaj zdjęcie z przodu lub tyłu pojazdu, tak aby na zdjęciu znalazła się tablica rejestracyjna.',
  YOUR_REPORT_NR: 'Twoje zgłoszenie nr',
  HAS_BEEN_RECEIVED_FOR_PROCESSING: 'zostało przyjęte do realizacji',
  WE_WILL_CONTACT_WITH_YOU_WITHIN_A_FEW_MINUTES: 'W ciągu **kilku minut** zadzwonimy by umówić usługę Assistance.',
  RECEIVE_LINK_VIA_SMS: 'Po rozmowie otrzymasz SMS-em link do śledzenia trasy pomocy drogowej.',
  CAN_NOT_READ_PLATE_NUMBER_FROM_IMAGE: 'Tablice rejestracyjne nie zostały poprawnie odczytane ze zdjęcia',
  CAN_NOT_READ_LOCATION_DATA: 'Lokalizacja miejsca zdarzenia nie została poprawnie odczytana',
  TRY_AGAIN_TO_LOAD_PHOTO_OR_MAKE_CALL:
    'Upewnij się, że tablice rejestracyjne są **dobrze widoczne** i wykonaj zdjęcie ponownie lub zadzwoń do nas by zamówić Assistance przez telefon.',
  MAKE_PHOTO_AGAIN: 'Zrób zdjęcie jeszcze raz',
  MAKE_CALL_AT: 'Zadzwoń pod',
  MAKE_CALL_TO_US: 'Zadzwoń do nas',
  CAN_NOT_READ_LOCALIZATION: 'Lokalizacja miejsca zdarzenia nie została odczytana',
  MAKE_CALL_TO_ORDER_ASSISTANCE: 'Zadzwoń do nas by zamówić Assistance przez telefon.',
  REQUIRED: 'Wymagane',
  FILE_TOO_LARGE: 'Przesłany plik jest za duży. Maksymalny rozmiar to 4 MB.',
};
